import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import * as _ from 'lodash'
import Toasted from 'vue-toasted'
import Vuelidate from 'vuelidate'
import VueHead from 'vue-head'

Vue.use(Vuex)
Vue.use(Toasted)
Vue.use(Vuelidate)
Vue.use(VueHead)

import App from '@/apps/default/App'

Vue.component('app', App)

import {
    NavbarPlugin,
    BreadcrumbPlugin,
    LayoutPlugin,
    CardPlugin,
    ButtonPlugin,
    CalendarPlugin,
    FormPlugin,
    FormCheckboxPlugin,
    FormRadioPlugin,
    FormInputPlugin,
    FormTextareaPlugin,
    FormGroupPlugin,
    FormSelectPlugin,
    FormTimepickerPlugin,
    FormFilePlugin,
    InputGroupPlugin,
    ProgressPlugin,
    TablePlugin,
    PaginationPlugin,
    ModalPlugin,
    CollapsePlugin,
    BadgePlugin,
    AlertPlugin,
    TabsPlugin,
    PopoverPlugin,
    ListGroupPlugin,
    SpinnerPlugin,
    ButtonGroupPlugin,
    SidebarPlugin,
    IconsPlugin,
    CarouselPlugin,
    FormDatepickerPlugin
} from 'bootstrap-vue'

Vue.use(NavbarPlugin)
Vue.use(BreadcrumbPlugin)
Vue.use(LayoutPlugin)
Vue.use(CardPlugin)
Vue.use(ButtonPlugin)
Vue.use(CalendarPlugin)
Vue.use(FormPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormRadioPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormSelectPlugin)
Vue.use(FormTimepickerPlugin)
Vue.use(FormFilePlugin)
Vue.use(InputGroupPlugin)
Vue.use(ProgressPlugin)
Vue.use(TablePlugin)
Vue.use(PaginationPlugin)
Vue.use(ModalPlugin)
Vue.use(CollapsePlugin)
Vue.use(BadgePlugin)
Vue.use(AlertPlugin)
Vue.use(TabsPlugin)
Vue.use(PopoverPlugin)
Vue.use(ListGroupPlugin)
Vue.use(AlertPlugin)
Vue.use(SpinnerPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(SidebarPlugin)
Vue.use(IconsPlugin)
Vue.use(CarouselPlugin)
Vue.use(FormDatepickerPlugin)

import moment from 'moment'

// date filter using moment
// source: https://github.com/brockpetrie/vue-moment/issues/75
// (replaces VueMoment and gets rid of annoying console warnings)
Vue.filter('moment', function (value, format) {
    if (value === null || value === undefined || format === undefined) {
        return ''
    }
    if (format === 'from') {
        return moment(value).fromNow()
    }
    return moment(value).format(format)
})

import HighchartsVue from 'highcharts-vue'

Vue.use(HighchartsVue)
import Highcharts from 'highcharts'
import * as more from 'highcharts/highcharts-more'
import * as bullet from 'highcharts/modules/bullet'

more(Highcharts)
bullet(Highcharts)

import VuePluralize from 'vue-pluralize'
Vue.use(VuePluralize)

// used for DietID
import VueFriendlyIframe from 'vue-friendly-iframe';
Vue.use(VueFriendlyIframe)

import VueMq from 'vue-mq'
Vue.use(VueMq, {
    breakpoints: { // default breakpoints - customize this
        sm: 540,
        md: 720,
        lg: 960,
        xl: 1140,
    },
    defaultBreakpoint: 'sm' // customize this for SSR
})

utils.registerComponents()

Vue.config.productionTip = api.inProduction

import {store} from './store'
import utils from '@/providers/Utils'
import api from '@/providers/Api'
import i18n from '@/providers/i18n'
import user from './User'
import auth from '@/providers/Authorization'

utils.addCustomMixin('api')
utils.addCustomMixin('i18n')
utils.addCustomMixin('user')
utils.addCustomMixin('auth')
utils.addCustomMixin('utils')

utils.addAuthorizationInterceptor(store, router, user)

Vue.config.devtools = !api.inProduction

const app = new Vue({
    el: '#root-app',
    store,
    router,
    api,
    i18n,
    user,
    auth,
    utils,
    methods: {
        isEmpty(obj) {
            return _.isEmpty(obj)
        }
    }
})

import * as Sentry from "@sentry/vue"
import {Integrations} from "@sentry/tracing"

// Sentry setup
Sentry.init({
    app,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing()],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
})

// Cypress setup
if (window.Cypress) {
    window.app = app
}

